import React, { Component } from 'react'

class SvgFile extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="12"
        viewBox="0 0 16 12"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M-5-7h25v25H-5z" />
          <g fill="#5B6982" fillRule="nonzero">
            <path d="M1 6.833h13.333a.833.833 0 1 0 0-1.666H1a.833.833 0 1 0 0 1.666z" />
            <path d="M8.744 10.41a.833.833 0 0 0 1.179 1.18l5-5a.833.833 0 0 0 0-1.18l-5-5a.833.833 0 1 0-1.179 1.18L13.154 6l-4.41 4.41z" />
          </g>
        </g>
      </svg>
    )
  }
}

export default SvgFile
